/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  AppProjectsOilSchemasSchemasBlendOut,
  AppProjectsOilSchemasSchemasUpdateOut,
  BlendCalculationResult,
  BlendsOut,
  CalculationResultUpdateOut,
  CalculationTaskOut,
  CalculationTaskRunStatus,
  CallbackRunRequest,
  CallbackRunResponse,
  HTTPValidationError,
  ProfilerMode,
  RJSFSchemas,
  SampleCalculationResult,
  SampleOut,
  SamplesOut
} from '../models/index';
import {
  AppProjectsOilSchemasSchemasBlendOutFromJSON,
  AppProjectsOilSchemasSchemasBlendOutToJSON,
  AppProjectsOilSchemasSchemasUpdateOutFromJSON,
  AppProjectsOilSchemasSchemasUpdateOutToJSON,
  BlendCalculationResultFromJSON,
  BlendCalculationResultToJSON,
  BlendsOutFromJSON,
  BlendsOutToJSON,
  CalculationResultUpdateOutFromJSON,
  CalculationResultUpdateOutToJSON,
  CalculationTaskOutFromJSON,
  CalculationTaskOutToJSON,
  CalculationTaskRunStatusFromJSON,
  CalculationTaskRunStatusToJSON,
  CallbackRunRequestFromJSON,
  CallbackRunRequestToJSON,
  CallbackRunResponseFromJSON,
  CallbackRunResponseToJSON,
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  ProfilerModeFromJSON,
  ProfilerModeToJSON,
  RJSFSchemasFromJSON,
  RJSFSchemasToJSON,
  SampleCalculationResultFromJSON,
  SampleCalculationResultToJSON,
  SampleOutFromJSON,
  SampleOutToJSON,
  SamplesOutFromJSON,
  SamplesOutToJSON
} from '../models/index';

export interface OilCreateBlendRequest {
  checkpointUuid: string;
  projectUuid: string;
  idempotencyKey: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilCreateSampleRequest {
  checkpointUuid: string;
  projectUuid: string;
  idempotencyKey: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilDeleteBlendRequest {
  blendUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilDeleteSampleRequest {
  sampleUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetBlendRequest {
  blendUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetBlendsRequest {
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetOilBlendRequest {
  blendUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetOilBlendsCalculationResultWidgetSchemasRequest {
  resultWidgetUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetOilBlendsCalculationResultsRequest {
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetOilCalculationTasksRequest {
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetOilSamplesCalculationResultWidgetSchemasRequest {
  resultWidgetUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetOilSamplesCalculationResultsRequest {
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetSampleRequest {
  sampleUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilGetSamplesRequest {
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilRunBlendCallbackRequest {
  blendUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  callbackRunRequest: CallbackRunRequest;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilRunOilCalculationTaskRequest {
  checkpointUuid: string;
  projectUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilRunSampleCallbackRequest {
  sampleUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  callbackRunRequest: CallbackRunRequest;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilUpdateBlendRequest {
  blendUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  body: object;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilUpdateOilBlendCalculationResultRequest {
  resultWidgetUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  body: object;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilUpdateOilSampleCalculationResultRequest {
  resultWidgetUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  body: object;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface OilUpdateSampleRequest {
  sampleUuid: string;
  checkpointUuid: string;
  projectUuid: string;
  body: object;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

/**
 *
 */
export class OilApi extends runtime.BaseAPI {
  /**
   * Create Blend
   */
  async oilCreateBlendRaw(
    requestParameters: OilCreateBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppProjectsOilSchemasSchemasBlendOut>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilCreateBlend().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilCreateBlend().'
      );
    }

    if (requestParameters['idempotencyKey'] == null) {
      throw new runtime.RequiredError(
        'idempotencyKey',
        'Required parameter "idempotencyKey" was null or undefined when calling oilCreateBlend().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['idempotencyKey'] != null) {
      headerParameters['idempotency-key'] = String(requestParameters['idempotencyKey']);
    }

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/blends`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AppProjectsOilSchemasSchemasBlendOutFromJSON(jsonValue)
    );
  }

  /**
   * Create Blend
   */
  async oilCreateBlend(
    requestParameters: OilCreateBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppProjectsOilSchemasSchemasBlendOut> {
    const response = await this.oilCreateBlendRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Create Sample
   */
  async oilCreateSampleRaw(
    requestParameters: OilCreateSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SampleOut>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilCreateSample().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilCreateSample().'
      );
    }

    if (requestParameters['idempotencyKey'] == null) {
      throw new runtime.RequiredError(
        'idempotencyKey',
        'Required parameter "idempotencyKey" was null or undefined when calling oilCreateSample().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['idempotencyKey'] != null) {
      headerParameters['idempotency-key'] = String(requestParameters['idempotencyKey']);
    }

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/samples`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SampleOutFromJSON(jsonValue));
  }

  /**
   * Create Sample
   */
  async oilCreateSample(
    requestParameters: OilCreateSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SampleOut> {
    const response = await this.oilCreateSampleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Delete Blend
   */
  async oilDeleteBlendRaw(
    requestParameters: OilDeleteBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['blendUuid'] == null) {
      throw new runtime.RequiredError(
        'blendUuid',
        'Required parameter "blendUuid" was null or undefined when calling oilDeleteBlend().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilDeleteBlend().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilDeleteBlend().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/blends/{blend_uuid}`
          .replace(`{${'blend_uuid'}}`, encodeURIComponent(String(requestParameters['blendUuid'])))
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete Blend
   */
  async oilDeleteBlend(
    requestParameters: OilDeleteBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.oilDeleteBlendRaw(requestParameters, initOverrides);
  }

  /**
   * Delete Sample
   */
  async oilDeleteSampleRaw(
    requestParameters: OilDeleteSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['sampleUuid'] == null) {
      throw new runtime.RequiredError(
        'sampleUuid',
        'Required parameter "sampleUuid" was null or undefined when calling oilDeleteSample().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilDeleteSample().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilDeleteSample().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/samples/{sample_uuid}`
          .replace(
            `{${'sample_uuid'}}`,
            encodeURIComponent(String(requestParameters['sampleUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete Sample
   */
  async oilDeleteSample(
    requestParameters: OilDeleteSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.oilDeleteSampleRaw(requestParameters, initOverrides);
  }

  /**
   * Get Blend
   */
  async oilGetBlendRaw(
    requestParameters: OilGetBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{[key: string]: RJSFSchemas}>> {
    if (requestParameters['blendUuid'] == null) {
      throw new runtime.RequiredError(
        'blendUuid',
        'Required parameter "blendUuid" was null or undefined when calling oilGetBlend().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetBlend().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetBlend().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/blends/{blend_uuid}`
          .replace(`{${'blend_uuid'}}`, encodeURIComponent(String(requestParameters['blendUuid'])))
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      runtime.mapValues(jsonValue, RJSFSchemasFromJSON)
    );
  }

  /**
   * Get Blend
   */
  async oilGetBlend(
    requestParameters: OilGetBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{[key: string]: RJSFSchemas}> {
    const response = await this.oilGetBlendRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get Blends
   */
  async oilGetBlendsRaw(
    requestParameters: OilGetBlendsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BlendsOut>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetBlends().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetBlends().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/blends`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => BlendsOutFromJSON(jsonValue));
  }

  /**
   * Get Blends
   */
  async oilGetBlends(
    requestParameters: OilGetBlendsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BlendsOut> {
    const response = await this.oilGetBlendsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get Oil Blend
   */
  async oilGetOilBlendRaw(
    requestParameters: OilGetOilBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters['blendUuid'] == null) {
      throw new runtime.RequiredError(
        'blendUuid',
        'Required parameter "blendUuid" was null or undefined when calling oilGetOilBlend().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetOilBlend().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetOilBlend().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/blends/{blend_uuid}/export`
          .replace(`{${'blend_uuid'}}`, encodeURIComponent(String(requestParameters['blendUuid'])))
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Get Oil Blend
   */
  async oilGetOilBlend(
    requestParameters: OilGetOilBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.oilGetOilBlendRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Получение схем результата расчёта смеси
   * Get Oil Blends Calculation Result Widget Schemas
   */
  async oilGetOilBlendsCalculationResultWidgetSchemasRaw(
    requestParameters: OilGetOilBlendsCalculationResultWidgetSchemasRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{[key: string]: RJSFSchemas}>> {
    if (requestParameters['resultWidgetUuid'] == null) {
      throw new runtime.RequiredError(
        'resultWidgetUuid',
        'Required parameter "resultWidgetUuid" was null or undefined when calling oilGetOilBlendsCalculationResultWidgetSchemas().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetOilBlendsCalculationResultWidgetSchemas().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetOilBlendsCalculationResultWidgetSchemas().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_results/blends/{result_widget_uuid}`
          .replace(
            `{${'result_widget_uuid'}}`,
            encodeURIComponent(String(requestParameters['resultWidgetUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      runtime.mapValues(jsonValue, RJSFSchemasFromJSON)
    );
  }

  /**
   * Получение схем результата расчёта смеси
   * Get Oil Blends Calculation Result Widget Schemas
   */
  async oilGetOilBlendsCalculationResultWidgetSchemas(
    requestParameters: OilGetOilBlendsCalculationResultWidgetSchemasRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{[key: string]: RJSFSchemas}> {
    const response = await this.oilGetOilBlendsCalculationResultWidgetSchemasRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Получение рассчитанных смесей
   * Get Oil Blends Calculation Results
   */
  async oilGetOilBlendsCalculationResultsRaw(
    requestParameters: OilGetOilBlendsCalculationResultsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<BlendCalculationResult>>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetOilBlendsCalculationResults().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetOilBlendsCalculationResults().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_results/blends`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(BlendCalculationResultFromJSON)
    );
  }

  /**
   * Получение рассчитанных смесей
   * Get Oil Blends Calculation Results
   */
  async oilGetOilBlendsCalculationResults(
    requestParameters: OilGetOilBlendsCalculationResultsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<BlendCalculationResult>> {
    const response = await this.oilGetOilBlendsCalculationResultsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Получение заданий на расчёт
   * Get Oil Calculation Tasks
   */
  async oilGetOilCalculationTasksRaw(
    requestParameters: OilGetOilCalculationTasksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CalculationTaskOut>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetOilCalculationTasks().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetOilCalculationTasks().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_task`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CalculationTaskOutFromJSON(jsonValue)
    );
  }

  /**
   * Получение заданий на расчёт
   * Get Oil Calculation Tasks
   */
  async oilGetOilCalculationTasks(
    requestParameters: OilGetOilCalculationTasksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CalculationTaskOut> {
    const response = await this.oilGetOilCalculationTasksRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Получение схем результата расчёта пробы
   * Get Oil Samples Calculation Result Widget Schemas
   */
  async oilGetOilSamplesCalculationResultWidgetSchemasRaw(
    requestParameters: OilGetOilSamplesCalculationResultWidgetSchemasRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{[key: string]: RJSFSchemas}>> {
    if (requestParameters['resultWidgetUuid'] == null) {
      throw new runtime.RequiredError(
        'resultWidgetUuid',
        'Required parameter "resultWidgetUuid" was null or undefined when calling oilGetOilSamplesCalculationResultWidgetSchemas().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetOilSamplesCalculationResultWidgetSchemas().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetOilSamplesCalculationResultWidgetSchemas().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_results/samples/{result_widget_uuid}`
          .replace(
            `{${'result_widget_uuid'}}`,
            encodeURIComponent(String(requestParameters['resultWidgetUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      runtime.mapValues(jsonValue, RJSFSchemasFromJSON)
    );
  }

  /**
   * Получение схем результата расчёта пробы
   * Get Oil Samples Calculation Result Widget Schemas
   */
  async oilGetOilSamplesCalculationResultWidgetSchemas(
    requestParameters: OilGetOilSamplesCalculationResultWidgetSchemasRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{[key: string]: RJSFSchemas}> {
    const response = await this.oilGetOilSamplesCalculationResultWidgetSchemasRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Получение рассчитанных проб
   * Get Oil Samples Calculation Results
   */
  async oilGetOilSamplesCalculationResultsRaw(
    requestParameters: OilGetOilSamplesCalculationResultsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<SampleCalculationResult>>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetOilSamplesCalculationResults().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetOilSamplesCalculationResults().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_results/samples`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SampleCalculationResultFromJSON)
    );
  }

  /**
   * Получение рассчитанных проб
   * Get Oil Samples Calculation Results
   */
  async oilGetOilSamplesCalculationResults(
    requestParameters: OilGetOilSamplesCalculationResultsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<SampleCalculationResult>> {
    const response = await this.oilGetOilSamplesCalculationResultsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Get Sample
   */
  async oilGetSampleRaw(
    requestParameters: OilGetSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{[key: string]: RJSFSchemas}>> {
    if (requestParameters['sampleUuid'] == null) {
      throw new runtime.RequiredError(
        'sampleUuid',
        'Required parameter "sampleUuid" was null or undefined when calling oilGetSample().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetSample().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetSample().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/samples/{sample_uuid}`
          .replace(
            `{${'sample_uuid'}}`,
            encodeURIComponent(String(requestParameters['sampleUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      runtime.mapValues(jsonValue, RJSFSchemasFromJSON)
    );
  }

  /**
   * Get Sample
   */
  async oilGetSample(
    requestParameters: OilGetSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{[key: string]: RJSFSchemas}> {
    const response = await this.oilGetSampleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get Samples
   */
  async oilGetSamplesRaw(
    requestParameters: OilGetSamplesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SamplesOut>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilGetSamples().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilGetSamples().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/samples`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => SamplesOutFromJSON(jsonValue));
  }

  /**
   * Get Samples
   */
  async oilGetSamples(
    requestParameters: OilGetSamplesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SamplesOut> {
    const response = await this.oilGetSamplesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Run Blend Callback
   */
  async oilRunBlendCallbackRaw(
    requestParameters: OilRunBlendCallbackRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CallbackRunResponse>> {
    if (requestParameters['blendUuid'] == null) {
      throw new runtime.RequiredError(
        'blendUuid',
        'Required parameter "blendUuid" was null or undefined when calling oilRunBlendCallback().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilRunBlendCallback().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilRunBlendCallback().'
      );
    }

    if (requestParameters['callbackRunRequest'] == null) {
      throw new runtime.RequiredError(
        'callbackRunRequest',
        'Required parameter "callbackRunRequest" was null or undefined when calling oilRunBlendCallback().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/blends/{blend_uuid}/run_callback`
          .replace(`{${'blend_uuid'}}`, encodeURIComponent(String(requestParameters['blendUuid'])))
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CallbackRunRequestToJSON(requestParameters['callbackRunRequest'])
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CallbackRunResponseFromJSON(jsonValue)
    );
  }

  /**
   * Run Blend Callback
   */
  async oilRunBlendCallback(
    requestParameters: OilRunBlendCallbackRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CallbackRunResponse> {
    const response = await this.oilRunBlendCallbackRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Запуск задания на расчёт
   * Run Oil Calculation Task
   */
  async oilRunOilCalculationTaskRaw(
    requestParameters: OilRunOilCalculationTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CalculationTaskRunStatus>> {
    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilRunOilCalculationTask().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilRunOilCalculationTask().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_tasks/run`
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CalculationTaskRunStatusFromJSON(jsonValue)
    );
  }

  /**
   * Запуск задания на расчёт
   * Run Oil Calculation Task
   */
  async oilRunOilCalculationTask(
    requestParameters: OilRunOilCalculationTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CalculationTaskRunStatus> {
    const response = await this.oilRunOilCalculationTaskRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Run Sample Callback
   */
  async oilRunSampleCallbackRaw(
    requestParameters: OilRunSampleCallbackRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CallbackRunResponse>> {
    if (requestParameters['sampleUuid'] == null) {
      throw new runtime.RequiredError(
        'sampleUuid',
        'Required parameter "sampleUuid" was null or undefined when calling oilRunSampleCallback().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilRunSampleCallback().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilRunSampleCallback().'
      );
    }

    if (requestParameters['callbackRunRequest'] == null) {
      throw new runtime.RequiredError(
        'callbackRunRequest',
        'Required parameter "callbackRunRequest" was null or undefined when calling oilRunSampleCallback().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/samples/{sample_uuid}/run_callback`
          .replace(
            `{${'sample_uuid'}}`,
            encodeURIComponent(String(requestParameters['sampleUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CallbackRunRequestToJSON(requestParameters['callbackRunRequest'])
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CallbackRunResponseFromJSON(jsonValue)
    );
  }

  /**
   * Run Sample Callback
   */
  async oilRunSampleCallback(
    requestParameters: OilRunSampleCallbackRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CallbackRunResponse> {
    const response = await this.oilRunSampleCallbackRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Update Blend
   */
  async oilUpdateBlendRaw(
    requestParameters: OilUpdateBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppProjectsOilSchemasSchemasUpdateOut>> {
    if (requestParameters['blendUuid'] == null) {
      throw new runtime.RequiredError(
        'blendUuid',
        'Required parameter "blendUuid" was null or undefined when calling oilUpdateBlend().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilUpdateBlend().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilUpdateBlend().'
      );
    }

    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling oilUpdateBlend().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/blends/{blend_uuid}`
          .replace(`{${'blend_uuid'}}`, encodeURIComponent(String(requestParameters['blendUuid'])))
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['body'] as any
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AppProjectsOilSchemasSchemasUpdateOutFromJSON(jsonValue)
    );
  }

  /**
   * Update Blend
   */
  async oilUpdateBlend(
    requestParameters: OilUpdateBlendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppProjectsOilSchemasSchemasUpdateOut> {
    const response = await this.oilUpdateBlendRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Изменение параметров отображения результатов расчёта смеси
   * Update Oil Blend Calculation Result
   */
  async oilUpdateOilBlendCalculationResultRaw(
    requestParameters: OilUpdateOilBlendCalculationResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CalculationResultUpdateOut>> {
    if (requestParameters['resultWidgetUuid'] == null) {
      throw new runtime.RequiredError(
        'resultWidgetUuid',
        'Required parameter "resultWidgetUuid" was null or undefined when calling oilUpdateOilBlendCalculationResult().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilUpdateOilBlendCalculationResult().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilUpdateOilBlendCalculationResult().'
      );
    }

    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling oilUpdateOilBlendCalculationResult().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_results/blends/{result_widget_uuid}`
          .replace(
            `{${'result_widget_uuid'}}`,
            encodeURIComponent(String(requestParameters['resultWidgetUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['body'] as any
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CalculationResultUpdateOutFromJSON(jsonValue)
    );
  }

  /**
   * Изменение параметров отображения результатов расчёта смеси
   * Update Oil Blend Calculation Result
   */
  async oilUpdateOilBlendCalculationResult(
    requestParameters: OilUpdateOilBlendCalculationResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CalculationResultUpdateOut> {
    const response = await this.oilUpdateOilBlendCalculationResultRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Изменение параметров отображения результатов расчёта пробы
   * Update Oil Sample Calculation Result
   */
  async oilUpdateOilSampleCalculationResultRaw(
    requestParameters: OilUpdateOilSampleCalculationResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CalculationResultUpdateOut>> {
    if (requestParameters['resultWidgetUuid'] == null) {
      throw new runtime.RequiredError(
        'resultWidgetUuid',
        'Required parameter "resultWidgetUuid" was null or undefined when calling oilUpdateOilSampleCalculationResult().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilUpdateOilSampleCalculationResult().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilUpdateOilSampleCalculationResult().'
      );
    }

    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling oilUpdateOilSampleCalculationResult().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/oil/calculation_results/samples/{result_widget_uuid}`
          .replace(
            `{${'result_widget_uuid'}}`,
            encodeURIComponent(String(requestParameters['resultWidgetUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['body'] as any
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CalculationResultUpdateOutFromJSON(jsonValue)
    );
  }

  /**
   * Изменение параметров отображения результатов расчёта пробы
   * Update Oil Sample Calculation Result
   */
  async oilUpdateOilSampleCalculationResult(
    requestParameters: OilUpdateOilSampleCalculationResultRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CalculationResultUpdateOut> {
    const response = await this.oilUpdateOilSampleCalculationResultRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Update Sample
   */
  async oilUpdateSampleRaw(
    requestParameters: OilUpdateSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AppProjectsOilSchemasSchemasUpdateOut>> {
    if (requestParameters['sampleUuid'] == null) {
      throw new runtime.RequiredError(
        'sampleUuid',
        'Required parameter "sampleUuid" was null or undefined when calling oilUpdateSample().'
      );
    }

    if (requestParameters['checkpointUuid'] == null) {
      throw new runtime.RequiredError(
        'checkpointUuid',
        'Required parameter "checkpointUuid" was null or undefined when calling oilUpdateSample().'
      );
    }

    if (requestParameters['projectUuid'] == null) {
      throw new runtime.RequiredError(
        'projectUuid',
        'Required parameter "projectUuid" was null or undefined when calling oilUpdateSample().'
      );
    }

    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling oilUpdateSample().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/projects/{project_uuid}/checkpoints/{checkpoint_uuid}/samples/{sample_uuid}`
          .replace(
            `{${'sample_uuid'}}`,
            encodeURIComponent(String(requestParameters['sampleUuid']))
          )
          .replace(
            `{${'checkpoint_uuid'}}`,
            encodeURIComponent(String(requestParameters['checkpointUuid']))
          )
          .replace(
            `{${'project_uuid'}}`,
            encodeURIComponent(String(requestParameters['projectUuid']))
          ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['body'] as any
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AppProjectsOilSchemasSchemasUpdateOutFromJSON(jsonValue)
    );
  }

  /**
   * Update Sample
   */
  async oilUpdateSample(
    requestParameters: OilUpdateSampleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AppProjectsOilSchemasSchemasUpdateOut> {
    const response = await this.oilUpdateSampleRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
